export enum TTaskViewTypes {
  DueToday = "dueToday",
  Upcoming = "upcoming",
}
